import React, { useState, useEffect } from 'react';
import ParameterTabs from "./ParameterTabs";
import BlanketTab from './BlanketTab';
import PlacementTab from './PlacementTab';
import PatternTabs from "./PatternTabs";
import layoutEngine from "../libraries/layoutEngine";
import ProjectManager from "../canvas/ProjectManager";


const ParametricSidePanel = ({ isOpen, onClose, aiLaunchRequestId = 0 }) => {
  const [activeTab, setActiveTab] = useState("PARAMETERS");
  const [hasOpened, setHasOpened] = useState(isOpen);
  const [hasMountedPatterns, setHasMountedPatterns] = useState(false);
  const [topCellName, setTopCellName] = useState("");
  const [cellNames, setCellNames] = useState(() =>
    layoutEngine.getAllCellNames()
  );


  const tabs = ["PARAMETERS",  "PATTERNS", "PLACEMENT"];
  useEffect(() => {
    const syncAvailableCells = () => {
      const nextCellNames = layoutEngine.getAllCellNames();
      setCellNames(nextCellNames);

      setTopCellName((current) => {
        if (current && nextCellNames.includes(current)) return current;

        const selectedCell = ProjectManager.getSelectedCell?.();
        const projectTopCell = ProjectManager.getTopCellName?.();
        const nextTopCell =
          (selectedCell && nextCellNames.includes(selectedCell) && selectedCell) ||
          (projectTopCell && nextCellNames.includes(projectTopCell) && projectTopCell) ||
          nextCellNames[0] ||
          "";

        if (nextTopCell) ProjectManager.setTopCellName?.(nextTopCell);
        return nextTopCell;
      });
    };

    syncAvailableCells();
    window.addEventListener("hierarchy-updated", syncAvailableCells);
    window.addEventListener("cell-changed", syncAvailableCells);

    return () => {
      window.removeEventListener("hierarchy-updated", syncAvailableCells);
      window.removeEventListener("cell-changed", syncAvailableCells);
    };
  }, []);

  useEffect(() => {
    if (aiLaunchRequestId > 0) {
      setActiveTab("PATTERNS");
    }
  }, [aiLaunchRequestId]);

  useEffect(() => {
    if (isOpen) setHasOpened(true);
  }, [isOpen]);

  useEffect(() => {
    if (activeTab === "PATTERNS") setHasMountedPatterns(true);
  }, [activeTab]);

  if (!isOpen && !hasOpened) return null;

  return (
    <div style={{
      position: 'fixed',
      left: '40px',
      top: '48px',
      height: 'calc(100vh - 48px)',
      width: '430px',
      backgroundColor: '#1e1e1e',
      color: '#fff',
      zIndex: 999,
      boxShadow: '2px 0 10px rgba(0,0,0,0.5)',
      borderRight: '1px solid #333',
      display: isOpen ? 'flex' : 'none',
      flexDirection: 'column',
      fontFamily: 'sans-serif'
    }}>
      
      {/* Header */}
     <div style={{
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: '#1e1e1e',
  padding: '8px 12px',
  borderBottom: '1px solid #333'
}}>
  {/* ❌ Close Button - Left */}
  <button onClick={onClose} style={{
    background: 'transparent',
    color: '#ccc',
    border: 'none',
    fontSize: '18px',
    cursor: 'pointer',
    fontWeight: 'bold',
  }}>
    ✕
  </button>

  {/* 📝 Top Cell Name Input - Right */}
  {/* <input
    type="text"
    placeholder="Enter Top Cell Name"
    value={topCellName}
    onChange={(e) => setTopCellName(e.target.value)}
    style={{
      padding: '6px 10px',
      fontSize: '12px',
      backgroundColor: '#2c2c2c',
      color: '#fff',
      border: '1px solid #444',
      borderRadius: '4px',
      width: '180px',
      outline: 'none',
    }}
  /> */}
  <select
  value={topCellName || ""}
  onChange={(e) => {
    const selected = e.target.value;
    setTopCellName(selected);
    ProjectManager.setTopCellName(selected);
  }}
  style={{
    padding: "6px 10px",
    fontSize: "12px",
    backgroundColor: "#2c2c2c",
    color: "#fff",
    border: "1px solid #444",
    borderRadius: "4px",
    width: "180px",
    outline: "none",
  }}
>
  {cellNames.map((cell) => (
    <option key={cell} value={cell}>
      {cell}
    </option>
  ))}
</select>
</div>


      {/* Tab Headers */}
      <div style={{
        backgroundColor: '#2c2c2c',
        borderBottom: '1px solid #444',
      }}>
        <div
          style={{
            display: 'flex',
            overflowX: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
          className="tab-strip"
        >
          {tabs.map((tab) => (
            <div
              key={tab}
              onClick={() => setActiveTab(tab)}
              style={{
                padding: '10px 12px',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: activeTab === tab ? 'bold' : 'normal',
                color: activeTab === tab ? '#00bcd4' : '#ccc',
                borderBottom: activeTab === tab ? '3px solid #00bcd4' : '3px solid transparent',
                whiteSpace: 'nowrap',
                transition: 'all 0.2s ease-in-out',
                flex: 'none',
              }}
            >
              {tab}
            </div>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div style={{
        flex: 1,
        padding: '14px',
        overflowY: 'auto',
        fontSize: '13px',
      }}>
        {activeTab === "PARAMETERS" && <ParameterTabs />}
        
        {(hasMountedPatterns || activeTab === "PATTERNS") && (
          <div style={{ display: activeTab === "PATTERNS" ? "block" : "none" }}>
            <PatternTabs
              topCellName={topCellName}
              aiLaunchRequestId={aiLaunchRequestId}
            />
          </div>
        )}
        {activeTab === "PLACEMENT" && <PlacementTab />}
      </div>

      {/* Hide Scrollbar CSS */}
      <style>{`
        .tab-strip::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};

export default ParametricSidePanel;
